// extracted by mini-css-extract-plugin
export var NavigationMobile = "NavigationMobile-module--NavigationMobile--55516";
export var hasMobileMenuOpen = "NavigationMobile-module--has-mobile-menu-open--474a7";
export var highlightedLink = "NavigationMobile-module--highlightedLink--58d69";
export var isActive = "NavigationMobile-module--isActive--6bdaa";